<template>
  <news-article-card>
    <nuxt-link
      :to="linkToArticle"
      class="relative h-full flex flex-col justify-end no-underline text-mouse p-4 rounded-lg overflow-hidden bg-transparent"
    >
      <strapi-image
        class="absolute top-0 left-0 w-full h-full -z-10 rounded-lg bg-cover bg-center"
        :image="article.thumbnailImage"
        :alt="article.title"
        as-background
      />
      <div
        class="news-article__veil absolute top-0 left-0 w-full h-full rounded-lg pointer-events-none"
      ></div>

      <div
        class="absolute top-4 left-4 bg-depth-0 px-3 py-1 rounded-md font-bold text-mouse capitalize z-10"
      >
        {{ article.type }}
      </div>

      <div class="relative z-20 min-h-[30%] md:min-h-[60%] lg:min-h-[40%]">
        <p class="mb-0 font-bold uppercase">
          <span class="text-rhino">
            {{ publishedAt }}
          </span>
          <template v-if="article.category !== 'None'">
            &nbsp;/&nbsp;
            <span class="font-bold text-mouse">{{ article.category }}</span>
          </template>
        </p>
        <h3 class="text-lg uppercase">
          {{ article.title }}
          <fa-icon :icon="faCircleArrowRight" class="text-brand ms-2 size-5" />
        </h3>
      </div>
    </nuxt-link>
  </news-article-card>
</template>

<script setup lang="ts">
import { faCircleArrowRight } from '@fortawesome/pro-solid-svg-icons';
import type { StrapiArticle } from '~/apollo/types/types';
import {
  useArticleLink,
  useArticlePublishedDate,
} from './features/useArticleFeatures';

const props = defineProps({
  article: { required: true, type: Object as PropType<StrapiArticle> },
});

const { publishedAt } = useArticlePublishedDate(props.article);
const { linkToArticle } = useArticleLink(props.article);
</script>

<style scoped>
.news-article__veil {
  background: linear-gradient(
    to bottom,
    transparent 40%,
    color-mix(in srgb, var(--color-depth-4) 80%, transparent) 60%,
    var(--color-depth-4) 100%
  );
}

@media (min-width: 768px) and (max-width: 1024px) {
  .news-article__veil {
    background: linear-gradient(
      to bottom,
      transparent 30%,
      color-mix(in srgb, var(--color-depth-4) 80%, transparent) 50%,
      var(--color-depth-4) 100%
    );
  }
}
</style>
